
const CUSTOM_STEPS = [
  {
    key: "sport",
    title: "WHAT SPORT DO YOU PLAY?",
    attributeKey: "att-what-sport",
    options: [
      { label: "Baseball", attributeOptionKey: "att-what-sport-baseball" },
      { label: "Fastpitch", attributeOptionKey: "att-what-sport-fastpitch" },
    ],
  },
  {
    key: "position",
    title: "WHAT POSITION DO YOU PLAY?",
    attributeKey: "att-what-position",
    options: [
      { label: "Infield", attributeOptionKey: "att-what-position-infield" },
      { label: "Outfield", attributeOptionKey: "att-what-position-outfield" },
      { label: "Pitcher", attributeOptionKey: "att-what-position-pitcher" },
      { label: "Catcher", attributeOptionKey: "att-what-position-catcher" },
      { label: "First Base", attributeOptionKey: "att-what-position-first-base" },
    ],
  },
  {
    key: "hand",
    title: "WHICH HAND DO YOU THROW WITH?",
    attributeKey: "att-what-hand",
    options: [
      { label: "Right", attributeOptionKey: "att-what-hand-right" },
      { label: "Left", attributeOptionKey: "att-what-hand-left" },
    ],
  },
  {
    key: "wrist",
    title: "What's your desired wrist fit?", //WHAT’S YOUR WRIST SIZE?
    attributeKey: "att-wrist-type",
    options: [
      { label: "Standard", attributeOptionKey: "att-wrist-type-standard" },
      { label: "Snug", attributeOptionKey: "att-wrist-type-youth" }, //Youth
    ],
  },
];

function injectExpiviLoader() {
  const container = document.querySelector(".expivi-page-container");
  if (!container) return;
  container.style.opacity = "1";

  if (container.querySelector(".expivi-loader")) return;

  const loader = document.createElement("div");
  loader.className = "expivi-loader";
  loader.innerHTML = `
    <div class="expivi-loader-inner">
      <div class="spinner"></div>
      <p>Loading your custom glove…</p>
    </div>
  `;

  container.prepend(loader);
  container.classList.add("expivi-loading");
}

function injectLoaderStyles() {
  if (document.getElementById("expivi-loader-style")) return;

  const style = document.createElement("style");
  style.id = "expivi-loader-style";
  style.innerHTML = `
    .expivi-page-container.expivi-loading > *:not(.expivi-loader) {
      visibility: hidden;
    }
    .expivi-loader {
      position: absolute;
      inset: 0;
      background: #fff;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .expivi-loader-inner {
      text-align: center;
      font-family: system-ui, sans-serif;
    }

    .expivi-loader-inner p {
      margin-top: 16px;
      font-size: 14px;
      color: #444;
    }

    .spinner {
      width: 42px;
      height: 42px;
      border: 3px solid #eee;
      border-top-color: #111;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
      margin: 0 auto;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;

  document.head.appendChild(style);
}
function hideExpiviLoader() {
  const container = document.querySelector(".expivi-page-container");
  if (!container) return;

  const loader = container.querySelector(".expivi-loader");
  if (!loader) return;

  loader.style.opacity = "0";
  loader.style.transition = "opacity 0.3s ease";

  setTimeout(() => {
    loader.remove();
    container.classList.remove("expivi-loading");
  }, 300);
}

async function finalizeExpiviUI() {
  // small safety delay for DOM stability
  await new Promise(r => setTimeout(r, 200));
  hideExpiviLoader();
}

document.addEventListener("DOMContentLoaded", () => {
  injectLoaderStyles();
  injectExpiviLoader();

  const state = {
    stepIndex: 0,
    selections: {}, // { sport: 'att-what-sport-baseball', ... }
    expiviReady: false,
    container: null,
  };

  const POSITION_ATTRIBUTE_ID = 271142;   // WHAT POSITION DO YOU PLAY?
  const PATTERN_ATTRIBUTE_ID  = 258321;   // Pattern Type

  const POSITION_TO_PATTERN = {
    660366: [626782, 645260], // Infield
    660366: [645260], // Infield
    660367: [644766], // Outfield
    660368: [632086], // Pitcher
    671259: [651987], // Catcher
    671260: [651650], // First Base
  };

  /* =========================
     LOAD CONFIG FROM URL
  ========================== */
  // const params = new URLSearchParams(window.location.search);
  // const configUUID = params.get("configuration");

  /* -----------------------------
     WAIT FOR EXPIVI + CONTAINER
  ------------------------------ */
  const waitForReady = setInterval(() => {
    const page = document.querySelector(".expivi-page-container");
    const expiviReady =
      window.expivi && window.expivi._events && window.expivi.setProductAttributeByKey;

    if (!page || !expiviReady) return;

    clearInterval(waitForReady);
    state.container = page;

    initExpivi();
    injectUI();
  }, 300);

  function ensurePreselection() {
    const step = CUSTOM_STEPS[state.stepIndex];
    if (!step) return;

    // If already selected, do nothing
    if (state.selections[step.key]) return;

    // Find first option and preselect it (UI only)
    const firstOption = step.options.find(o => o.attributeOptionKey);
    if (firstOption) {
      state.selections[step.key] = firstOption.attributeOptionKey;
    }
  }

  /* -----------------------------
     EXPIVI READY
  ------------------------------ */
  function initExpivi() {
    window.expivi._events.onReady.subscribe(() => {
      state.expiviReady = true;
      restoreSelections();
      render();
    });
  }

  /* -----------------------------
     RESTORE PRESELECTED
  ------------------------------ */
  function restoreSelections() {
    window.expivi.getProductAttributes().then(attrs => {
      attrs.forEach(attr => {
        const step = CUSTOM_STEPS.find(s => s.attributeKey === attr.key);
        if (step && attr.selected_value_key) {
          state.selections[step.key] = attr.selected_value_key;
        }
      });
    });
    // 👇 ensure first step has a preselection
    ensurePreselection();
    render();
  }

  /* -----------------------------
     UI INJECTION
  ------------------------------ */
  function injectUI() {
    const root = document.createElement("div");
    root.id = "custom-configurator";
    state.container.prepend(root);
  }

  /* -----------------------------
     RENDER
  ------------------------------ */
  function render() {
    const root = document.getElementById("custom-configurator");
    if (!root) return;

    const step = CUSTOM_STEPS[state.stepIndex];
    const selected = state.selections[step.key];

    root.innerHTML = `
    <div class="intro-overlay" ref="overlay">
    <div class="intro-modal">
    <div class="step-banner">
    <div class="step-main">
    <div class="step-containers">
      <ul class="step-list">
        ${CUSTOM_STEPS.map(
      (s, i) => `
          <li class="${i === state.stepIndex ? "active" : i < state.stepIndex ? "completed" : ""}">
          <span>${i + 1}</span>
           <strong>${s.key}</strong>
          </li>`
    ).join("")}
      </ul>
      <ul>${CUSTOM_STEPS.map(
      (s, i) => `
          <li class="${i === state.stepIndex ? "active" : i < state.stepIndex ? "completed" : ""}">
            <svg
            width="121"
            height="23"
            viewBox="0 0 121 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
            d="M107.661 0H0L13.3386 11.5L0 23H107.661L121 11.5L107.661 0Z"
            fill="${i - 1 < state.stepIndex ? '#4797F8' : '#CECECE'}"
            />
            </svg>
          </li>`
    ).join("")}
        </ul>
        </div>
        </div>
        <div class="step-questions">
        <div class="step-indexes">
      <h2>${step.title}</h2>

      <div class="intro-actions">
        ${step.options
        .map(
          o => `
          <button
            class="intro-btn option-btn ${selected === o.attributeOptionKey ? "selected" : ""}"
            data-value="${o.attributeOptionKey}"
          >
            ${o.label}
          </button>`
        )
        .join("")}
      </div>

      <div class="step-buttons">
        <button id="prevBtn" class="intro-btn secondary" ${state.stepIndex === 0 ? "disabled" : ""}>
            <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.47594 10.0492C5.54502 10.1135 5.60043 10.1912 5.63886 10.2774C5.67729 10.3637 5.69795 10.4568 5.69962 10.5512C5.70128 10.6456 5.68392 10.7394 5.64855 10.8269C5.61319 10.9145 5.56055 10.994 5.49379 11.0608C5.42702 11.1275 5.34749 11.1802 5.25994 11.2155C5.17238 11.2509 5.07861 11.2683 4.9842 11.2666C4.88979 11.2649 4.79668 11.2443 4.71043 11.2058C4.62418 11.1674 4.54656 11.112 4.48219 11.0429L1.43437 7.99605L0.9375 7.49917L1.43437 7.0023L4.48125 3.95542C4.6138 3.82728 4.79138 3.75632 4.97574 3.75784C5.1601 3.75935 5.33648 3.83322 5.46691 3.96352C5.59734 4.09382 5.67137 4.27014 5.67306 4.4545C5.67474 4.63886 5.60396 4.8165 5.47594 4.94917L3.62906 6.79605L13.3594 6.79605C13.5459 6.79605 13.7247 6.87013 13.8566 7.00199C13.9884 7.13385 14.0625 7.31269 14.0625 7.49917C14.0625 7.68565 13.9884 7.86449 13.8566 7.99636C13.7247 8.12822 13.5459 8.2023 13.3594 8.2023L3.62906 8.2023L5.47594 10.0492Z"
            fill="black"
            />
            </svg>
          Previous
        </button>
        <button id="nextBtn" class="intro-btn secondary" ${!selected ? "disabled" : ""}>
          ${state.stepIndex === CUSTOM_STEPS.length - 1 ? "Next" : "Next"}
                        <svg
                width="36"
                height="16"
                viewBox="0 0 36 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.5461 15.6099H0L7.80497 7.80497L0 0H6.5461L14.3511 7.80497L6.5461 15.6099Z"
                  fill="white"
                />
                <path
                  d="M17.1203 15.6099H10.5742L18.3792 7.80497L10.5742 0H17.1203L24.9253 7.80497L17.1203 15.6099Z"
                  fill="white"
                />
                <path
                  d="M27.6955 15.6099H21.1494L28.9544 7.80497L21.1494 0H27.6955L35.5005 7.80497L27.6955 15.6099Z"
                  fill="white"
                />
              </svg>
        </button>
      </div>
      </div>
        </div>
        </div>
    `;

    bindEvents();
  }

  /* -----------------------------
     EVENTS
  ------------------------------ */
  function bindEvents() {
    document.querySelectorAll(".option-btn").forEach(btn => {
      btn.addEventListener("click", () => {
        const step = CUSTOM_STEPS[state.stepIndex];
        state.selections[step.key] = btn.dataset.value;
        render();
      });
    });

    const prevBtn = document.getElementById("prevBtn");
    if (prevBtn) {
      prevBtn.onclick = () => {
        if (state.stepIndex > 0) {
          state.stepIndex--;
          render();
        }
      };
    }

    const nextBtn = document.getElementById("nextBtn");
    if (nextBtn) {
      nextBtn.onclick = () => applyAndNext();
    }
  }

// Build reverse map (Pattern → Position)
const PATTERN_TO_POSITION = {};
Object.entries(POSITION_TO_PATTERN).forEach(([positionId, patternIds]) => {
  patternIds.forEach(patternId => {
    PATTERN_TO_POSITION[patternId] = Number(positionId);
  });
});

// ===============================
// STATE
// ===============================
let isSyncing = false;
let lastPositionValue = null;
let lastPatternValue = null;

// ===============================
// INIT
// ===============================
window.expivi._events.onReady.subscribe(async function () {
  console.log("Expivi ready - Pattern/Position sync enabled");

  await initState();

  window.expivi._events.onChange.subscribe(() => {
    syncPositionAndPattern();
  });
});

// ===============================
// INIT STATE
// ===============================
async function initState() {
  try {
    const attrs = await window.expivi.getProductAttributes();

    const positionAttr = attrs.find(a => a.id === POSITION_ATTRIBUTE_ID);
    const patternAttr  = attrs.find(a => a.id === PATTERN_ATTRIBUTE_ID);

    lastPositionValue = positionAttr?.selected_value_id ?? null;
    lastPatternValue  = patternAttr?.selected_value_id ?? null;

  } catch (err) {
    console.error("Init error:", err);
  }
}

// ===============================
// MAIN SYNC LOGIC
// ===============================
async function syncPositionAndPattern() {
  if (isSyncing) return;

  try {
    const attrs = await window.expivi.getProductAttributes();

    const positionAttr = attrs.find(a => a.id === POSITION_ATTRIBUTE_ID);
    const patternAttr  = attrs.find(a => a.id === PATTERN_ATTRIBUTE_ID);

    if (!positionAttr || !patternAttr) return;

    const currentPosition = positionAttr.selected_value_id ?? null;
    const currentPattern  = patternAttr.selected_value_id ?? null;

    const positionChanged = currentPosition !== lastPositionValue;
    const patternChanged  = currentPattern !== lastPatternValue;

    if (!positionChanged && !patternChanged) return;

    isSyncing = true;

    // =====================================
    // 1️⃣ POSITION → PATTERN
    // =====================================
    if (positionChanged && !patternChanged) {

      const allowedPatterns = POSITION_TO_PATTERN[currentPosition] || [];

      if (allowedPatterns.length) {

        // If current pattern is already valid → keep it
        if (!allowedPatterns.includes(currentPattern)) {

          const newPattern = allowedPatterns[0]; // default

          await window.expivi.setProductAttribute(
            PATTERN_ATTRIBUTE_ID,
            newPattern
          );

          lastPositionValue = currentPosition;
          lastPatternValue  = newPattern;

          isSyncing = false;
          return;
        }
      }
    }

    // =====================================
    // 2️⃣ PATTERN → POSITION
    // =====================================
    if (patternChanged && !positionChanged) {

      const newPosition = PATTERN_TO_POSITION[currentPattern];

      if (newPosition && currentPosition !== newPosition) {

        await window.expivi.setProductAttribute(
          POSITION_ATTRIBUTE_ID,
          newPosition
        );

        lastPatternValue  = currentPattern;
        lastPositionValue = newPosition;

        isSyncing = false;
        return;
      }
    }

    // =====================================
    // 3️⃣ BOTH CHANGED (edge case)
    // =====================================
    if (positionChanged && patternChanged) {

      const allowedPatterns = POSITION_TO_PATTERN[currentPosition] || [];

      if (!allowedPatterns.includes(currentPattern)) {

        const newPosition = PATTERN_TO_POSITION[currentPattern];

        if (newPosition && currentPosition !== newPosition) {
          await window.expivi.setProductAttribute(
            POSITION_ATTRIBUTE_ID,
            newPosition
          );

          lastPatternValue  = currentPattern;
          lastPositionValue = newPosition;

          isSyncing = false;
          return;
        }
      }
    }

    // =====================================
    // UPDATE STATE
    // =====================================
    lastPositionValue = currentPosition;
    lastPatternValue  = currentPattern;

    isSyncing = false;

  } catch (err) {
    console.error("Sync error:", err);
    isSyncing = false;
  }
}

  async function syncPatternWithPosition() {
    try {
      const attrs = await window.expivi.getProductAttributes();

      const positionAttr = attrs.find(a => a.id === POSITION_ATTRIBUTE_ID);
      if (!positionAttr) return;

      const selectedValueId = positionAttr.selected_value_id;
      if (!selectedValueId) return;

      const patternValueId = POSITION_TO_PATTERN[selectedValueId];
      if (!patternValueId) return;

      const patternAttr = attrs.find(a => a.id === PATTERN_ATTRIBUTE_ID);
      if (!patternAttr) return;

      // If already selected, do nothing
      if (patternAttr.selected_value_id === patternValueId) return;

      // console.log("Updating Pattern Type automatically");

      await window.expivi.setProductAttribute(
        PATTERN_ATTRIBUTE_ID,
        patternValueId
      );

    } catch (err) {
      console.error("Pattern sync error:", err);
    }
  }

  /* -----------------------------
     APPLY TO EXPIVI
  ------------------------------ */
  function applyAndNext() {
    if (!state.expiviReady) return;

    const step = CUSTOM_STEPS[state.stepIndex];
    const valueKey = state.selections[step.key];
    if (!valueKey) return;

    window.expivi.setProductAttributeByKey(step.attributeKey, valueKey);


    // syncPatternWithPosition();
    syncPositionAndPattern();

    if (state.stepIndex < CUSTOM_STEPS.length - 1) {
      state.stepIndex++;
      ensurePreselection(); // 👈 IMPORTANT
      render();
    } else {
      finishConfigurator();
    }
  }

  function finishConfigurator() {
    const root = document.getElementById("custom-configurator");
    if (root) {
      root.style.display = "none";
    }

    // console.log("Configurator finished");
  }
});



// Initialize Expivi
window.addEventListener("DOMContentLoaded", function () {
  const customizerMarkup = `
          <div class="customizer-header">
              <div class="customizer-logo">
                  <img src="https://cdn.shopify.com/s/files/1/0674/4929/1071/files/emery-logo.png?v=1767265139" alt="Emery Logo">
              </div>
              <button id="save-design-btn"><span>Save my design</span> <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.11133 0.0498047H7.54785C7.82922 0.0498869 8.09892 0.162337 8.29785 0.361328L9.80176 1.86523C9.89648 1.96001 9.95017 2.08866 9.9502 2.22266V8.88867C9.9502 9.1701 9.83865 9.44065 9.63965 9.63965C9.44065 9.83865 9.1701 9.9502 8.88867 9.9502H1.11133C0.829904 9.9502 0.559348 9.83865 0.360352 9.63965C0.161355 9.44065 0.0498047 9.1701 0.0498047 8.88867V1.11133C0.0498047 0.829904 0.161355 0.559348 0.360352 0.360352C0.559348 0.161355 0.829904 0.0498047 1.11133 0.0498047ZM3.2832 8.93848H6.7168V5.50586H3.2832V8.93848ZM3.2832 2.27246H6.7168V1.06152H3.2832V2.27246ZM8.93848 2.43164L8.92383 2.41699L7.81348 1.30566L7.72754 1.2207V2.22266C7.72742 2.50392 7.61589 2.77376 7.41699 2.97266C7.21808 3.17154 6.94827 3.28312 6.66699 3.2832H3.33301C3.05173 3.28312 2.78192 3.17154 2.58301 2.97266C2.38411 2.77376 2.27258 2.50392 2.27246 2.22266V1.06152H1.06152V8.93848H2.27246V5.55566C2.27246 5.27434 2.38415 5.00464 2.58301 4.80566C2.78193 4.60674 3.0517 4.49423 3.33301 4.49414H6.66699C6.9483 4.49423 7.21807 4.60674 7.41699 4.80566C7.61585 5.00464 7.72754 5.27434 7.72754 5.55566V8.93848H8.93848V2.43164Z" fill="white" stroke="black" stroke-width="0.1"/>
      </svg></button>
          </div>
          <div class="save-design-form" style="display: none;" id="save-design-form">
              <form id="save-design-form-inner" method="post">
                <input type="text" name="first_name" placeholder="First Name" required>
                <input type="hidden" name="last_name" placeholder="Last Name">
                <input type="email" name="email" placeholder="Email Address" required>
                <input type="text" name="phone" placeholder="Phone Number">
                <button type="submit">Save My Design</button>
                <div class="form-message"></div>
              </form>
              <p class="note-custom">Save your glove design to come back to it later! We will email or text your unique glove link to you so you can finish your glove design.</p>
          </div>`;
  const addCustomizerHeader = () => {
    const container = document.querySelector(".configurator-container");
    if (!container || container.querySelector(".customizer-header"))
      return false;
    container.insertAdjacentHTML("afterbegin", customizerMarkup);
    return true;
  };

  const observeBuilder = () => {
    if (addCustomizerHeader()) return;
    const observer = new MutationObserver(() => {
      if (addCustomizerHeader()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  observeBuilder();

  /* -----------------------------
    Toggle logic
  ----------------------------- */
  function generateUUID() {
    return crypto.randomUUID();
  }
  document.addEventListener("click", function (e) {
    const saveBtn = e.target.closest("#save-design-btn");
    if (!saveBtn) return;
    toggleSaveForm();
  });

  function toggleSaveForm(forceClose = null) {
    const form = document.getElementById("save-design-form");
    const mbntNma = document.querySelector("#save-design-btn"); 
    const triggerBtn = document.querySelector("#save-design-btn span"); 
    const options = document.querySelector(
      ".configurator-container .option-container"
    );

    if (!form || !options || !triggerBtn) return;

    const isCurrentlyOpen = form.style.display === "block";

    // Determine final state
    const shouldClose =
      forceClose !== null ? forceClose : isCurrentlyOpen;

    if (shouldClose) {
      // Close form
      form.style.display = "none";
      options.style.display = "";
      mbntNma.classList.remove('good-to');

      // Revert button text
      triggerBtn.textContent = "Save My Design";
    } else {
      // Open form
      form.style.display = "block";
      options.style.display = "none";
      mbntNma.classList.add('good-to');

      // Change button text
      triggerBtn.textContent = "Close ✕";
    }
  }

  document.addEventListener("submit", async function (e) {
    const form = e.target.closest("#save-design-form-inner");
    if (!form) return;

    e.preventDefault();

    const data = Object.fromEntries(new FormData(form).entries());

    const submitBtn = form.querySelector('button[type="submit"]');
    const inputs = form.querySelectorAll("input, button");

    // Inline message container (create once)
    let msg = form.querySelector(".form-message");
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "form-message";
      msg.style.marginTop = "12px";
      form.appendChild(msg);
    }

    // Loader element
    let loader = submitBtn.querySelector(".btn-loader");
    if (!loader) {
      loader = document.createElement("span");
      loader.className = "btn-loader";
      loader.innerHTML = " Saving...";
      loader.style.marginLeft = "8px";
    }

    // Reset message
    msg.textContent = "";
    msg.style.color = "";

    // Disable UI
    inputs.forEach(el => el.disabled = true);
    submitBtn.appendChild(loader);

    try {
      // console.log('starting it');
      // 1. Save Expivi configuration
      const expiviResult = await window.expivi.saveConfiguration();
      // console.log(expiviResult);
      if (!expiviResult) {
        throw new Error("Expivi save failed");
      }
      // console.log('starting good.');

      const payload = {
        row_uuid: generateUUID(),
        expivi_uuid: expiviResult.bundle_uuid,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
        expivi_data: expiviResult,
      };

      const res = await fetch("https://phpstack-1572275-6151450.cloudwaysapps.com/api/save-design.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error();

      // ✅ SUCCESS
      msg.textContent = "Design saved successfully. Check your email.";
      msg.style.color = "green";

      // Reset form
      form.reset();

      // Toggle form & options
      setTimeout(() => {
        toggleSaveForm(false);
        // Reset message
        msg.textContent = "";
        msg.style.color = "";
      }, 1500); // 1.5 seconds delay

      // window.location.href = "/"
    } catch (err) {
      console.error(err);
      msg.textContent = "Failed to save design. Please try again.";
      msg.style.color = "red";
    } finally {
      // Restore UI
      inputs.forEach(el => el.disabled = false);
      loader.remove();
    }
  });
});

function sendToKlaviyo(data) {
  if (!window._klOnsite) return;

  const LIST_ID = "TnUmHL"; // Replace with your real list ID

  const formattedPhone = formatPhone(data.phone);

  const designLink = "https://emerygloveco.com/apps/configurator?catalogue=10121701949759&design=" + data.row_uuid;

  // -------------------------------
  // 1️⃣ Identify / Create Profile
  // -------------------------------
  window._klOnsite.push(['identify', {
    email: data.email,
    first_name: data.first_name,
    last_name: data.last_name,
    phone_number: formattedPhone
  }]);

  // -------------------------------
  // 2️⃣ Subscribe to List (Email + SMS)
  // -------------------------------
  window._klOnsite.push(['subscribe', {
    list: LIST_ID,
    email: data.email,
    phone_number: formattedPhone,
    sms_consent: true
  }]);

  // -------------------------------
  // 3️⃣ Track "Saved Glove Design" Event
  // -------------------------------
  window._klOnsite.push(['track', 'Saved Glove Design', {
    email: data.email,
    configuration_uuid: data.row_uuid,
    expivi_uuid: data.expivi_uuid,
    design_link: designLink
  }]);
}


function formatPhone(phone) {
  if (!phone) return null;

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length === 10) {
    return '+1' + cleaned; // US
  }

  if (cleaned.length > 10) {
    return '+' + cleaned;
  }

  return null;
}


function getSelectedMaterialName(matgroup) {
  const selectedMaterialId = matgroup.selected_value_value?.material_id;
  if (!selectedMaterialId) return "Not selected";

  const av = matgroup.attribute_values?.[0];
  const materials = av?.attribute_value_valuable?.material_group?.materials?.data;
  if (!Array.isArray(materials)) return "Not selected";

  const match = materials.find(
    m => m.attributes?.id === selectedMaterialId
  );

  return match?.attributes?.material_name || "Not selected";
}

window.addEventListener('load', function () {

  const state = {
    steps: [],          // type === "step"
    items: [],          // inner attributes
    stepStats: new Map()
  };

  const userTouchedItems = new Set();

  const ALLOWED_STEP_IDS = [258331, 258332, 258352];

  /* -------------------------
     Helpers
  ------------------------- */

  function getTabs() {
    return document.querySelectorAll(
      '.v-tab[data-xpv-attribute-step-id]'
    );
  }

  function splitAttributes(attrs) {
    // 1. Top-level steps only
    state.steps = attrs.filter(
      a => a.type === "step" && ALLOWED_STEP_IDS.includes(a.id)
    );

    // 2. Index attributes by parent_id
    const byParent = {};
    attrs.forEach(a => {
      if (!byParent[a.parent_id]) byParent[a.parent_id] = [];
      byParent[a.parent_id].push(a);
    });

    // 3. Collect items per step (questions + matgroups)
    state.stepItemsMap = {};

    state.steps.forEach(step => {
      const collected = [];

      // DFS traversal
      function walk(parentId) {
        const children = byParent[parentId] || [];

        children.forEach(child => {
          if (child.type === "question" || child.type === "matgroup") {
            collected.push(child);
          } else if (child.type === "step") {
            // container only, go deeper
            walk(child.id);
          }
        });
      }

      walk(step.id);
      state.stepItemsMap[step.id] = collected;
    });
  }

  function computeStepStats() {
    state.stepStats.clear();

    state.steps.forEach(step => {
      const stepId = step.id;

      const innerItems = state.items.filter(
        item => item.parent_id === stepId
      );

      const total = innerItems.length;

      const remaining = innerItems.filter(item => {
        // remaining if selected_value_id is null / undefined / 0
        return !item.selected_value_id;
      }).length;

      state.stepStats.set(stepId, {
        total,
        remaining
      });
    });
  }

  function renderTabBadges() {
    getTabs().forEach(tab => {
      const stepId = Number(
        tab.getAttribute('data-xpv-attribute-step-id')
      );

      const stats = state.stepStats.get(stepId);
      if (!stats) return;

      let badge = tab.querySelector('.xpv-remaining');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'xpv-remaining';
        tab.appendChild(badge);
      }

      badge.textContent =
        stats.remaining > 0
          ? `${stats.remaining} Remaining`
          : `0 Remaining`;
    });
  }

  document.addEventListener("click", e => {
    // Find nearest attribute container
    const attrContainer = e.target.closest(
      ".v-expansion-panel[data-xpv-attribute-id]"
    );

    if (!attrContainer) return;

    const attrId = Number(
      attrContainer.getAttribute("data-xpv-attribute-id")
    );

    if (!attrId) return;

    // Mark as user-touched
    userTouchedItems.add(attrId);

    refresh();
  });

  function refresh() {
    computeStepStats();
    renderTabBadges();
  }

  function createSidebarContainer() {
    const parent = document.querySelector(".expivi-page-container");
    if (!parent) return null;

    let sidebar = parent.querySelector("#expivi-sidebar");
    if (!sidebar) {
      sidebar = document.createElement("aside");
      sidebar.id = "expivi-sidebar";
      sidebar.className = "expivi-sidebar";

      parent.prepend(sidebar);
    }

    // 🔹 Ensure inner container exists
    let inner = sidebar.querySelector(".expivi-sidebar-inner");
    if (!inner) {
      inner = document.createElement("div");
      inner.className = "expivi-sidebar-inner";
      sidebar.appendChild(inner);
    }

    return inner; // return inner container (recommended)
  }

  function getSelectedValueLabel(attribute) {
    if (!attribute.attribute_values || !attribute.selected_value_id) {
      return "—";
    }

    const selected = attribute.attribute_values.find(
      v => v.id === attribute.selected_value_id
    );

    return selected ? selected.name : "—";
  }

  // Trigger Complete step button
  function triggerCollapseButton() {
    const parent = document.querySelector(".expivi-sidebar-inner");
    if (!parent) return;

    parent.classList.toggle("active");
  }

  function renderSidebar() {
    const sidebar = createSidebarContainer();
    if (!sidebar) return;
    sidebar.innerHTML = "";

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = 'completed-steps';
    btn.textContent = "COMPLETED STEPS";

    btn.addEventListener("click", triggerCollapseButton);

    sidebar.appendChild(btn);

    state.steps.forEach(step => {
      const stepEl = document.createElement("div");
      stepEl.className = "sidebar-step";

      stepEl.innerHTML = `<h4>${step.name}</h4>`;

      const list = document.createElement("ul");

      (state.stepItemsMap[step.id] || []).forEach(item => {
        const li = document.createElement("li");

        let selectedText = "Not selected";

        if (item.type === "question") {
          const v = item.attribute_values?.find(
            v => v.id === item.selected_value_id
          );
          selectedText = v?.name || "Not selected";
        }

        if (item.type === "matgroup") {
          selectedText = getSelectedMaterialName(item);
        }

        li.innerHTML = `<span class="item-name">${item.name}</span> <span class="item-value">${selectedText}</span>`;
        list.appendChild(li);
      });

      stepEl.appendChild(list);
      sidebar.appendChild(stepEl);
    });
  }


  /* -------------------------
     Update Colors & Design Image
  ------------------------- */
  function resolveSelectedValue2(attr) {
    const sel = attr.selected_value_value;
    if (!sel) return null;

    // material group
    if (sel.material_id) {
      const materials =
        attr.attribute_values?.[0]
          ?.attribute_value_valuable
          ?.material_group
          ?.materials
          ?.data || [];

      return materials.find(m => m.id === sel.material_id)?.attributes || null;
    }

    // normal attribute
    if (sel.attribute_value_id) {
      return attr.attribute_values?.find(
        v => v.id === sel.attribute_value_id
      ) || null;
    }

    return null;
  }

  async function syncPanelMaterialMeta() {
    const attrs = await window.expivi.getProductAttributes();
    const mainpanels = document.querySelectorAll('div[data-xpv-attribute-id="258332"] .v-expansion-panel');
    if (!mainpanels) return;

    mainpanels.forEach(panel => {

      const content = panel.querySelector(".v-expansion-panel-content");
      if (!content) return;

      const attrContainer = content.querySelector(
        ".container.container--fluid[data-xpv-attribute-id]"
      );
      if (!attrContainer) return;

      const attributeId = Number(
        attrContainer.getAttribute("data-xpv-attribute-id")
      );
      if (!attributeId) return;

      const attr = attrs.find(a => a.id === attributeId);
      if (!attr) return;

      const resolved = resolveSelectedValue2(attr);
      if (!resolved) return;

      const materialName =
        resolved.material_name || resolved.name || "";

      const thumbnailUrl =
        resolved.thumbnail_url || resolved.thumbnail || "";

      // 🔥 UPDATE PANEL META
      panel.querySelector('button.v-expansion-panel-header').setAttribute("data-material-name", materialName);
      panel.querySelector('button.v-expansion-panel-header').style.setProperty("--box-thumbnail", `url("${thumbnailUrl}")`);
    });
  }

  /* -------------------------
     Expivi Lifecycle
  ------------------------- */

  const params = new URLSearchParams(window.location.search);
  const designUUID = params.get("design");

  window.expivi._events.onReady.subscribe(function () {
    // console.log('Expivi ready');

    window.expivi._dispatch('client_ready').then(function () {
      // window.expivi.autoRotateYAxis();

      window.expivi.getProductAttributes().then(function (attrs) {
        // console.log('Attributes loaded', attrs);
        finalizeExpiviUI();

        if (!Array.isArray(attrs)) return;
        splitAttributes(attrs);
        renderSidebar(); // 👈 add this
        refresh();
 const presetId = params.get("preset_id");                                                                                                         
          if (presetId) {                                                                                                                                   
            (async () => {                                                                                                                                  
              try {                                                                                                                                         
                const res = await fetch(                                                                                                                    
                  `https://expivi.net/api/product_preset/find/${encodeURIComponent(presetId)}?include=constraints`,                                         
                  { headers: { Authorization: `Bearer ${window.expivi.apiToken}`, Accept: "application/json" } }                                            
                );
                if (!res.ok) throw new Error("Preset fetch " + res.status);
                const json = await res.json();
                const cfg = json?.data?.attributes?.configuration || json?.data?.configuration;
                if (!cfg || !Array.isArray(cfg.configured_products)) throw new Error("Malformed preset");
                const ok = await window.expivi.loadConfiguration({
                  bundle_uuid: cfg.bundle_uuid,
                  configured_products: cfg.configured_products,
                });
                if (ok) {
                  const custom = document.getElementById("custom-configurator");
                  if (custom) custom.style.display = "none";
                }
              } catch (err) {
                console.error("Preset load failed:", err);
              }
            })();
            return;
          }
          
        if (!designUUID) return;
        // console.log("Design UUID detected:", designUUID);
        restoreDesign(designUUID);
      });
    });
  });

  window.expivi._events.onChange.subscribe(function (event) {
    if (event?.name !== 'frame') {
      // console.log('change event', event);
    }

    // Re-fetch to stay accurate
    window.expivi.getProductAttributes().then(function (attrs) {
      if (!Array.isArray(attrs)) return;

      splitAttributes(attrs);
      syncPanelMaterialMeta();
      renderSidebar();
      refresh();
    });
  });

  /**
   * ----------------------------------------
   * STEP 2: Restore design by UUID
   * ----------------------------------------
   */
  async function restoreDesign(designUUID) {
    try {
      // console.log("Restoring design:", designUUID);

      const res = await fetch(
        `https://phpstack-1572275-6151450.cloudwaysapps.com/api/get-design.php?uuid=${encodeURIComponent(
          designUUID
        )}`,
        { method: "GET" }
      );

      if (!res.ok) throw new Error("Failed to fetch design");

      const json = await res.json();

      if (!json.success || !json.data?.expivi_data) {
        throw new Error("Invalid design response");
      }

      const expiviData = json.data.expivi_data;

      if (
        !expiviData.bundle_uuid ||
        !Array.isArray(expiviData.configured_products)
      ) {
        throw new Error("Malformed Expivi configuration");
      }

      const ok = await window.expivi.loadConfiguration({
        bundle_uuid: expiviData.bundle_uuid,
        configured_products: expiviData.configured_products,
      });

      if (!ok) {
        console.error("Expivi rejected configuration");
      } else {
        // console.log("Design restored successfully");

        // Optional: hide custom configurator UI
        const custom = document.getElementById("custom-configurator");
        if (custom) custom.style.display = "none";
      }
    } catch (err) {
      console.error("Restore failed:", err);
    }
  }
});



/* Prev next button and title */
window.addEventListener('load', function () {

  function initStepNavigation() {
    const tablist = document.querySelector('[role="tablist"]');
    if (!tablist) return;

    // Avoid duplicate buttons
    if (document.querySelector('.xpv-step-nav')) return;

    const nav = document.createElement('div');
    nav.className = 'xpv-step-nav';

    const prevBtn = document.createElement('button');
    prevBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.47594 10.0492C5.54502 10.1135 5.60043 10.1912 5.63886 10.2774C5.67729 10.3637 5.69795 10.4568 5.69962 10.5512C5.70128 10.6456 5.68392 10.7394 5.64855 10.8269C5.61319 10.9145 5.56055 10.994 5.49379 11.0608C5.42702 11.1275 5.34749 11.1802 5.25994 11.2155C5.17238 11.2509 5.07861 11.2683 4.9842 11.2666C4.88979 11.2649 4.79668 11.2443 4.71043 11.2058C4.62418 11.1674 4.54656 11.112 4.48219 11.0429L1.43437 7.99605L0.9375 7.49917L1.43437 7.0023L4.48125 3.95542C4.6138 3.82728 4.79138 3.75632 4.97574 3.75784C5.1601 3.75935 5.33648 3.83322 5.46691 3.96352C5.59734 4.09382 5.67137 4.27014 5.67306 4.4545C5.67474 4.63886 5.60396 4.8165 5.47594 4.94917L3.62906 6.79605L13.3594 6.79605C13.5459 6.79605 13.7247 6.87013 13.8566 7.00199C13.9884 7.13385 14.0625 7.31269 14.0625 7.49917C14.0625 7.68565 13.9884 7.86449 13.8566 7.99636C13.7247 8.12822 13.5459 8.2023 13.3594 8.2023L3.62906 8.2023L5.47594 10.0492Z" fill="black"/></svg> <span>Previous</span>';
    prevBtn.type = 'button';

    const nextBtn = document.createElement('button');
    nextBtn.innerHTML = '<span>Next</span> <svg width="36" height="16" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5461 15.6099H0L7.80497 7.80497L0 0H6.5461L14.3511 7.80497L6.5461 15.6099Z" fill="white"/><path d="M17.1208 15.6099H10.5747L18.3797 7.80497L10.5747 0H17.1208L24.9258 7.80497L17.1208 15.6099Z" fill="white"/><path d="M27.695 15.6099H21.1489L28.9539 7.80497L21.1489 0H27.695L35.5 7.80497L27.695 15.6099Z" fill="white"/></svg>';
    nextBtn.type = 'button';

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);

    tablist.insertAdjacentElement('afterend', nav);

    prevBtn.addEventListener('click', goToPreviousStep);
    nextBtn.addEventListener('click', goToNextStep);

    updateNavButtons();
  }

  function getTabs() {
    return Array.from(
      document.querySelectorAll('.v-tab[data-xpv-attribute-step-id]')
    );
  }

  function getActiveTabIndex() {
    return getTabs().findIndex(tab =>
      tab.classList.contains('v-tab--active')
    );
  }

  function activateTabByIndex(index) {
    const tabs = getTabs();
    if (index < 0 || index >= tabs.length) return;

    tabs[index].click();
  }

  function goToPreviousStep() {
    const panel = getActiveStepPanel();
    const items = getStepItems(panel);

    if (this.classList.contains('show-popup')) {
      document.getElementById('custom-configurator').style.display = 'block';
    }

    if (!items.length) {
      activateTabByIndex(getActiveTabIndex() - 1);
      return;
    }

    let currentIndex = getActiveItemIndex(items);

    if (currentIndex > 0) {
      activateItem(items, currentIndex - 1);
      return;
    }

    // First item → go to previous step
    activateTabByIndex(getActiveTabIndex() - 1);
  }

  function goToNextStep() {
    const panel = getActiveStepPanel();
    const items = getStepItems(panel);

    // No items → go to next step
    if (!items.length) {
      activateTabByIndex(getActiveTabIndex() + 1);
      return;
    }

    let currentIndex = getActiveItemIndex(items);

    // No active item yet → activate first
    if (currentIndex === -1) {
      activateItem(items, 0);
      return;
    }

    // Next item exists
    if (currentIndex < items.length - 1) {
      activateItem(items, currentIndex + 1);
      return;
    }

    // Last item → go to next step
    activateTabByIndex(getActiveTabIndex() + 1);
  }

  function updateNavButtons() {
    const index = getActiveTabIndex();
    const tabs = getTabs();

    const panel = getActiveStepPanel();
    const items = getStepItems(panel) || [];
    const currentIndex = getActiveItemIndex(items);

    const prevBtn = document.querySelector('.xpv-step-nav button:first-child');
    const nextBtn = document.querySelector('.xpv-step-nav button:last-child');

    if (!prevBtn || !nextBtn) return;

    const prevSpan = prevBtn.querySelector('span');

    /* --------------------
      PREVIOUS BUTTON TEXT
    -------------------- */
    if (index === 0 ) {
      if(currentIndex === 0){
        // first tab + first item
        prevSpan.innerHTML = 'BACK TO SET UP';
        prevBtn.classList.add('show-popup');
      }else{
        prevSpan.innerHTML = 'Previous';
        prevBtn.classList.remove('show-popup');
      }
    } else {
        prevSpan.innerHTML = 'Previous';
        prevBtn.classList.remove('show-popup');
    }

    /* --------------------
      PREVIOUS BUTTON STATE
      (always enabled, unless you want to disable it explicitly)
    -------------------- */
    prevBtn.disabled = false;

    /* --------------------
      NEXT BUTTON STATE
    -------------------- */
    const isLastTab = index === tabs.length - 1;
    const isLastItem = currentIndex === items.length - 1;

    if (isLastTab && isLastItem) {
      nextBtn.disabled = true;
    } else {
      nextBtn.disabled = false;
    }
  }

  function getActiveStepPanel() {
    const activeTab = document.querySelector('.v-tab.v-tab--active');
    if (!activeTab) return null;

    const href = activeTab.getAttribute('href');
    if (!href) return null;

    return document.querySelector(href);
  }

  function getStepItems(panel) {
    if (!panel) return [];

    return Array.from(
      panel.querySelectorAll('div[data-xpv-attribute-id].v-expansion-panel')
    ).filter(item => {
      // ignore empty items
      return item.children.length > 0;
    });
  }

  function getActiveItemIndex(items) {
    return items.findIndex(item =>
      item.classList.contains('v-expansion-panel--active')
    );
  }

  function activateItem(items, index) {
    const item = items[index];
    if (!item) return;

    const headerButton = item.querySelector('button.v-expansion-panel-header');
    if (headerButton) {
      headerButton.click();
    }
  }


  /* ----------------------------------
     Step Title Injection
  ---------------------------------- */

  function updateStepTitle() {
    const activeTab = document.querySelector('.v-tab.v-tab--active');
    if (!activeTab) return;

    // Clone tab to safely remove remaining badge
    const clone = activeTab.cloneNode(true);
    const remaining = clone.querySelector('.xpv-remaining');
    if (remaining) remaining.remove();

    const stepName = clone.textContent.trim();

    const href = activeTab.getAttribute('href');
    if (!href) return;

    const panel = document.querySelector(href);
    if (!panel) return;

    // Remove previously injected title
    panel.querySelectorAll('.xpv-step-title').forEach(el => el.remove());

    const h3 = document.createElement('h3');
    h3.className = 'xpv-step-title';
    h3.textContent = stepName;

    panel.insertAdjacentElement('afterbegin', h3);
  }

  /* -----------------------------
     Watch Step Changes
  ----------------------------- */

  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.v-tab[data-xpv-attribute-step-id]');
    if (!tab) return;

    setTimeout(() => {
      updateNavButtons();
      updateStepTitle();
    }, 0);
  });

  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.xpv-step-nav button');
    if (!tab) return;

    setTimeout(() => {
      updateNavButtons();
    }, 0);
  });


  /* -----------------------------
     Init when tabs exist
  ----------------------------- */

  const initTimer = setInterval(() => {
    if (document.querySelector('.v-tab[data-xpv-attribute-step-id]')) {
      clearInterval(initTimer);
      initStepNavigation();
      updateStepTitle();
    }
  }, 300);
  
});



// Apply to all color button code
(function () {
  const TARGET_TAB_ID =
    'div[data-xpv-attribute-id="258332"]';
  let observerStarted = false;


  // -------------------------------
  // Change all colors of Design
  // -------------------------------
  async function applyColorToAllFromAttribute(attributeId) {
    try {
      const attrs = await window.expivi.getProductAttributes();

      // 1. Find the source attribute
      const sourceAttr = attrs.find(a => a.id === attributeId);
      if (!sourceAttr) {
        console.error("Attribute not found:", attributeId);
        return;
      }
      // console.log(sourceAttr);

      // 2. Get selected material_id
      const selectedMaterialId = sourceAttr.selected_value_value?.material_id;
      // console.log(selectedMaterialId);

      if (!selectedMaterialId) {
        console.error("No selected material_id");
        return;
      }

      // 3. Resolve material_name
      const materialGroup =
        sourceAttr.attribute_values?.[0]
          ?.attribute_value_valuable
          ?.material_group;

      if (!materialGroup?.materials?.data) {
        console.error("Material group not found");
        return;
      }

      const selectedMaterial = materialGroup.materials.data.find(
        m => m.id === selectedMaterialId
      );

      if (!selectedMaterial) {
        console.error("Material not found in group");
        return;
      }

      const materialName = selectedMaterial.attributes.material_name;
      // console.log("Apply color:", materialName);

      // 4. Apply to ALL color-related material groups
      for (const attr of attrs) {
        if (attr.type !== "matgroup") continue;

        const mg =
          attr.attribute_values?.[0]
            ?.attribute_value_valuable
            ?.material_group;

        if (!mg?.materials?.data) continue;

        const match = mg.materials.data.find(
          m => m.attributes.material_name === materialName
        );

        if (!match) continue;

        // Apply material
        window.expivi.setProductAttribute(
          attr.id,
          { material_id: match.id }
        );
      }

      // console.log("Color applied to all");

    } catch (err) {
      console.error("Apply to all failed:", err);
    }
  }

  function resolveSelectedValue(attr) {
    const sel = attr.selected_value_value;
    if (!sel) return null;

    // material group
    if (sel.material_id) {
      const materials =
        attr.attribute_values?.[0]
          ?.attribute_value_valuable
          ?.material_group
          ?.materials
          ?.data || [];

      return materials.find(m => m.id === sel.material_id)?.attributes || null;
    }

    // normal attribute
    if (sel.attribute_value_id) {
      return attr.attribute_values?.find(
        v => v.id === sel.attribute_value_id
      ) || null;
    }

    return null;
  }

  // -------------------------------
  // Inject buttons into panels
  // -------------------------------
  async function injectApplyButtons(tabEl) {

    const panels = tabEl.querySelectorAll(".v-expansion-panel");
    if (!panels.length) return;
    // console.log(panels);

    // preload Expivi attributes ONCE
    const attrs = await window.expivi.getProductAttributes();

    panels.forEach((panel) => {
      if (panel.querySelector(".apply-to-color")) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "apply-to-color";
      btn.textContent = "Apply to All Colors";
      btn.style.marginTop = "10px";

      panel.appendChild(btn);

      // ---------- FIND ATTRIBUTE ID ----------
      const panelContent = panel.querySelector(".v-expansion-panel-content");
      if(panelContent){
        if (!panelContent) return;

        const attrContainer = panelContent.querySelector(
          ".container.container--fluid[data-xpv-attribute-id]"
        );
        if (!attrContainer) return;

        const attributeId = Number(
          attrContainer.getAttribute("data-xpv-attribute-id")
        );
        if (!attributeId) return;
        // console.log(attributeId);
        // ---------- FIND ATTRIBUTE IN EXPIVI ----------
        const sourceAttr = attrs.find(a => a.id === attributeId);
        if (!sourceAttr) return;

        const resolved = resolveSelectedValue(sourceAttr);
        if (!resolved) return;
        // console.log(resolved);
        const materialName =
          resolved.material_name || resolved.name || null;

        const thumbnailUrl =
          resolved.thumbnail_url ||
          resolved.thumbnail ||
          null;

        // ---------- STORE ON PANEL ----------
        if (thumbnailUrl) {
          panel.querySelector('button.v-expansion-panel-header').style.setProperty("--box-thumbnail", `url("${thumbnailUrl}")`);
        }

        if (materialName) {
          panel.querySelector('button.v-expansion-panel-header').setAttribute("data-material-name", materialName);
        }
      }



      btn.addEventListener("click", async () => {
        // const panel = btn.closest('.v-expansion-panel[data-xpv-attribute-id]');
        // if (!panel) return;
        // // console.log(panel);
        btn.disabled = true;
        btn.classList.add("loading");

        // 1. Go to expansion panel content
        const panelContent = panel.querySelector(".v-expansion-panel-content");
        if (!panelContent) {
          console.error("Expansion panel content not found");
          return;
        }
        // console.log(panelContent);

        // 2. Find the attribute container inside it
        const attrContainer = panelContent.querySelector(
          ".container.container--fluid[data-xpv-attribute-id]"
        );

        if (!attrContainer) {
          console.error("Attribute container not found");
          return;
        }
        // console.log(attrContainer);

        // 3. Read attribute ID
        const attributeId = Number(
          attrContainer.getAttribute("data-xpv-attribute-id")
        );

        if (!attributeId) {
          console.error("Invalid attribute ID");
          return;
        }
        // console.log(attributeId);

        try {
          await applyColorToAllFromAttribute(attributeId);
        } catch (err) {
          console.error("Apply to all failed:", err);
        } finally {
          btn.disabled = false;
          btn.classList.remove("loading");
        }
      });
    });
  }

  // -------------------------------
  // Observe DOM until tab appears
  // -------------------------------
  function observeForTab() {
    if (observerStarted) return;
    observerStarted = true;

    const observer = new MutationObserver(() => {
      const tab = document.querySelector(TARGET_TAB_ID);
      // console.log(tab);
      if (tab) {
        // console.log('found it');
        observer.disconnect();
        injectApplyButtons(tab);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // -------------------------------
  // Listen for tab clicks
  // -------------------------------
  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".v-tab[data-xpv-attribute-step-id]");
    if (!tab) return;

    // Start observing AFTER click
    observeForTab();
  });
})();


// Add to cart button on personalizaton tab
(function () {
  const TARGET_ATTRIBUTE_ID = "258352";
  const ADD_TO_CART_CLASS = "custom-add-to-cart";

  // -----------------------------------
  // Observe DOM for target attribute
  // -----------------------------------
  function observeForTargetAttribute() {
    const container = document.querySelector(".expivi-page-container");
    if (!container) return;

    const observer = new MutationObserver(() => {
      const targetDiv = document.querySelector(
        `div[data-xpv-attribute-id="${TARGET_ATTRIBUTE_ID}"]`
      );

      if (!targetDiv) return;

      // Stop observing once found
      observer.disconnect();

      injectAddToCartButton(targetDiv);
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  }

  // -----------------------------------
  // Inject Add to Cart button
  // -----------------------------------
  function injectAddToCartButton(targetDiv) {
    // Prevent duplicates
    if (targetDiv.querySelector(`.${ADD_TO_CART_CLASS}`)) return;

    const btnWrapper = document.createElement("div");
    btnWrapper.style.marginTop = "24px";
    btnWrapper.style.textAlign = "center";

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = ADD_TO_CART_CLASS;
    btn.textContent = "Add to Cart";

    btn.addEventListener("click", async () => {
      if (btn.disabled) return; // prevent double click

      // 🔒 lock button
      btn.disabled = true;
      btn.classList.add("is-loading");

      // Optional: swap text
      const originalText = btn.innerHTML;
      btn.innerHTML = `<span class="loader"></span> Processing...`;

      try {
        await triggerExpiviSubmit();
      } catch (err) {
        console.error(err);

        // 🔓 unlock on failure
        btn.disabled = false;
        btn.classList.remove("is-loading");
        btn.innerHTML = originalText;
      }
    });

    btnWrapper.appendChild(btn);
    targetDiv.appendChild(btnWrapper);
  }

  // -----------------------------------
  // Trigger Expivi real submit
  // -----------------------------------
  function triggerExpiviSubmit() {
    const form = document.querySelector("#xpv-summary-form");
    if (!form) {
      console.error("Expivi summary form not found");
      return;
    }

    const submitBtn = form.querySelector('button[type="button"]');
    if (!submitBtn) {
      console.error("Submit button not found in summary form");
      return;
    }

    submitBtn.click();
  }

  // -----------------------------------
  // Listen for tab clicks
  // -----------------------------------
  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".v-tab[data-xpv-attribute-step-id]");
    if (!tab) return;

    // Start observing AFTER tab click
    setTimeout(observeForTargetAttribute, 0);
  });
})();



// Add to cart image process with order
(function () {
  // document.addEventListener("click", async function (e) {
  //   const btn = e.target.closest(".expivi-add-to-cart");
  //   if (!btn) return;

  //   e.preventDefault();
  //   btn.disabled = true;
  //   btn.textContent = "Preparing your design...";

  //   try {
  //     // 1. Take screenshots
  //     const screenshots = await captureExpiviScreenshots();
  //     console.log(screenshots);

  //     // 2. Upload screenshots
  //     const uploadRes = await fetch(
  //       "https://phpstack-1572275-6151450.cloudwaysapps.com/api/upload-screenshots.php",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           images: screenshots
  //         })
  //       }
  //     );

  //     const uploadJson = await uploadRes.json();
  //     console.log(uploadJson);
  //     if (!uploadJson.success) throw new Error("Upload failed");

  //     // 3. Attach image URLs to cart form
  //     attachImagesToForm(uploadJson.urls);

  //     // 4. Submit original form
  //     // document.getElementById("xpv-summary-form").submit();

  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to prepare design. Please try again.");
  //     btn.disabled = false;
  //     btn.textContent = "Add to cart";
  //   }
  // });

  // async function captureExpiviScreenshots() {
  //   const views = [
  //     "FIT_OBJECT_FRONT",
  //     "FIT_OBJECT_BACK",
  //     "FIT_OBJECT_LEFT",
  //     "FIT_OBJECT_RIGHT"
  //   ];

  //   const result = {};

  //   for (const view of views) {
  //     const base64 = await window.expivi.getScreenshot(
  //       1080,
  //       1080,
  //       view,
  //       "image/png"
  //     );

  //     result[view] = base64;
  //   }

  //   return result;
  // }

  // function attachImagesToForm(urls) {
  //   const form = document.getElementById("xpv-summary-form");

  //   Object.entries(urls).forEach(([key, url]) => {
  //     const input = document.createElement("input");
  //     input.type = "hidden";
  //     input.name = `properties[${key.replace("FIT_OBJECT_", "Preview ")}]`;
  //     input.value = url;
  //     form.appendChild(input);
  //   });
  // }
})();

/*************************************************
 * EXPIVI SAFE ADD TO CART INTERCEPT + SCREENSHOTS
 *************************************************/

(function () {
  let isProcessingAddToCart = false;
  let allowNextClick = false;

  document.addEventListener(
    "click",
    async function (e) {
      const btn = e.target.closest(".expivi-add-to-cart");
      if (!btn) return;

      // ❌ Block Expivi click for now
      e.preventDefault();
      e.stopImmediatePropagation();

      btn.disabled = true;
      btn.classList.add("loading");

      try {

        // 1️⃣ Your async logic
        const imageUrls = await runBeforeAddToCart();
        const screenshots = imageUrls.images;
        // console.log(screenshots);
        
        // 1️⃣ Save configuration
        const config = await window.expivi.saveConfiguration(512, 512, window.camera_position);

        if (!config || !config.configured_products) {
          throw new Error("Failed to save configuration");
        }

        // 2️⃣ Send config to Expivi backend
        const res = await fetch("/apps/configurator", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            configuration: config.configured_products,
            productId: btn.dataset.productId
          })
        });

        const result = await res.json();
        // console.log(result);

        if (!result.variant_id) {
          throw new Error("Variant not created");
        }
        // console.log(result);

        // 1. Clean text values
        const options = sanitizeOptions(result.options);
        // console.log(options);

        const optionsWithImages = attachImagesToOptions(
          options,
          screenshots
        );

        // Add to cart
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: result.variant_id,
            quantity: 1,
            properties: optionsWithImages
          })
        });

        // 5️⃣ Redirect
        window.location.href = "/cart";

      } catch (err) {
        console.error("Add to cart failed", err);
      } finally {
        btn.disabled = false;
        btn.classList.remove("loading");
      }
    },
    true // 👈 capture phase (required)
  );

  // -------------------------------
  // PRE-CART ASYNC FLOW
  // -------------------------------
  async function runBeforeAddToCart() {
    await waitForExpiviReady();

    // 1. Take screenshots
    const images = await getExpiviScreenshots();
    const designUuid = generateUUID();

    // 3. Upload to Node.js
    const imageUrls = await uploadScreenshotsToNode(images, designUuid);

    return {
      uuid: designUuid,
      images: imageUrls
    };
  }

  async function uploadScreenshotsToNode(images, designUuid) {
    const endpoint = "https://glove.emerygloveco.com/upload/v2";
    const uploads = [];

    let index = 1;
    for (const [view, base64] of Object.entries(images)) {
      const cleanBase64 = base64.replace(/^data:image\/\w+;base64,/, "");
      const blob = base64ToBlob(cleanBase64, "image/png");

      const form = new FormData();
      form.append("canvas", blob, `${designUuid}-${view}.png`);
      form.append("view", view);
      form.append("uuid", designUuid);

      uploads.push(
        fetch(endpoint, {
          method: "POST",
          body: form
        }).then(r => r.json())
      );

      index++;
    }

    const responses = await Promise.all(uploads);

    return responses.map(r => r.file);
  }

  function base64ToBlob(base64, mime = "image/png") {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: mime });
  }

  function attachImagesToOptions(options, images) {
    if (!Array.isArray(images) || !images.length) return options;

    images.forEach((url) => {
      if (typeof url !== "string") return;

      const lower = url.toLowerCase();

      if (lower.includes("-front")) {
        options["Design Image – Front"] = url;
      } else if (lower.includes("-back")) {
        options["Design Image – Back"] = url;
      } else if (lower.includes("-left")) {
        options["Design Image – Left"] = url;
      } else if (lower.includes("-right")) {
        options["Design Image – Right"] = url;
      }
    });

    return options;
  }

  function sanitizeOptions(options) {
    const cleaned = {};

    Object.keys(options).forEach((key) => {
      try {
        let newKey = cleanOptionKey(key);
        let newValue = cleanOptionValue(options[key]);
        cleaned[newKey] = newValue;

        // 🔥 Auto-set Position based on Pattern
        if (newKey === "Pattern types") {
          const detectedPosition = getPositionFromPattern(newValue);

          if (detectedPosition) {
            cleaned["Position"] = detectedPosition;
          }
        }
        
      }catch(innerErr){
        console.error("Error processing option:", key, innerErr);
      }
    });

    return cleaned;
  }

  function cleanOptionValue(value) {
    if (typeof value !== "string") return value;

    // Split at first @ and trim
    return value.split("@")[0].trim();
  }

  function cleanOptionKey(key) {
    if (typeof key !== "string") return key;
    let cleanedKey = key;
    // Special rename rule
    if (cleanedKey === "Finger hood/pad (1)") {
      cleanedKey = "Finger hood/pad color";
    }

    return cleanedKey;
  }
  
  function getPositionFromPattern(patternValue) {
    try {
      if (!patternValue || typeof patternValue !== "string") return null;

      const value = patternValue.toLowerCase();

      if (value.includes("infield")) return "Infield";
      if (value.includes("outfield")) return "Outfield";
      if (value.includes("pitch")) return "Pitcher";
      if (value.includes("first base")) return "First Base";
      if (value.includes("catch")) return "Catcher";

      return null;
    } catch (err) {
      console.error("Pattern parsing error:", err);
      return null;
    }
  }
  function generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // -------------------------------
  // SCREENSHOT HELPER
  // -------------------------------
  async function getExpiviScreenshots() {
    if (!window.expivi || !expivi.getScreenshot) {
      return {};
    }
    const screenshots = {};

    screenshots.front = await expivi.getScreenshot(
      1080,
      1080,
      "FIT_OBJECT_FRONT",
      "image/png"
    );

    await delay(250);

    screenshots.back =  await expivi.getScreenshot(
        1080,
        1080,
        "FIT_OBJECT_BACK",
        "image/png"
      );
    //   await expivi.getScreenshot(1480, 1480, 'CUSTOM_CAMERA_POSITION', 'image/png', {
    //       position: {
    //               x: 150.972054933085746,
    //             y: -60.532997719505182,
    //           z: -240.3668386956782181
    //         },
    //       quaternion: {
    //             w: 0.7061126771698161,
    //           x: -0.026408121740431705,
    //             y: 0.7071125320273149,
    //         z: 0.026445515614884476
    //     }
    // });

      await delay(250);

      screenshots.left = await expivi.getScreenshot(
        1080,
        1080,
        "FIT_OBJECT_LEFT",
        "image/png"
      );

      await delay(250);

      screenshots.right = await expivi.getScreenshot(
        1080,
        1080,
        "FIT_OBJECT_RIGHT",
        "image/png"
      );

      return screenshots;
  }

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  // -------------------------------
  // WAIT FOR EXPIVI FULLY READY
  // -------------------------------
  function waitForExpiviReady() {
    return new Promise(resolve => {
      let attempts = 0;

      const check = () => {
        attempts++;

        if (
          window.expivi &&
          typeof expivi.getScreenshot === "function" &&
          typeof expivi.saveConfiguration === "function"
        ) {
          resolve();
          return;
        }

        if (attempts > 60) {
          console.warn("Expivi not fully ready, continuing anyway");
          resolve();
          return;
        }

        setTimeout(check, 100);
      };

      check();
    });
  }


  function injectInfoButton() {
  const labels = document.querySelectorAll(
    'div[data-xpv-attribute-id="258315"] > div > label'
  );

  labels.forEach(label => {
    if (label.querySelector('.info-btn')) return;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "info-btn";
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" class="info-icon" style="width:18px;height:18px;">
        <path fill="currentColor"
          d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z">
        </path>
      </svg>
    `;

    const tooltip = document.createElement("div");
    tooltip.className = "custom-tooltip";
    tooltip.innerHTML =
      'For More Information <a href="https://emerygloveco.com/pages/glove-prep-service" target="_blank">Click Here</a>';

    let hideTimeout;

    btn.addEventListener("mouseenter", function () {
      clearTimeout(hideTimeout);
      tooltip.classList.add("show");
    });

    btn.addEventListener("mouseleave", function () {
      hideTimeout = setTimeout(() => {
        tooltip.classList.remove("show");
      }, 200);
    });

    /* Click toggle */
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      tooltip.classList.toggle("show");
    });

    /* Keep tooltip open when hovering tooltip */
    tooltip.addEventListener("mouseenter", function () {
      clearTimeout(hideTimeout);
    });

    tooltip.addEventListener("mouseleave", function () {
      tooltip.classList.remove("show");
    });
    label.appendChild(btn);
    label.appendChild(tooltip);
  });
}

/* Watch for Expivi DOM updates */
const observer = new MutationObserver(() => {
  injectInfoButton();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

/* Initial run */
injectInfoButton();

/* Hide tooltip when clicking outside */
document.addEventListener("click", function () {
  document.querySelectorAll(".custom-tooltip.show").forEach(t => {
    t.classList.remove("show");
  });
});
})();